import { useRef, useState } from "react";
import { useSendEmail } from "../../../../utils/customHooks";

import {
	Section,
	TextRow,
	SectionHeading,
	FormContainer,
	DescriptionContainer,
	Form,
	Input,
	FormButton,
	NotificationBar,
	NotificationContainer,
	SkillWrapper,
	SkillContainer,
} from "./styles";

import FileInput from "../../../Molecules/Careers/FileInput";

import successIcon from "../../../../Assets/Images/NotificationBar/success.webp";
import warningIcon from "../../../../Assets/Images/NotificationBar/warning.webp";

const HeroSection = (props) => {
	const [formData, setFormData] = useState({
		fullName: "",
		email: "",
		position: props.shortTitle,
		cv: null,
	});
	const { sendEmail, validationErrors, setValidationErrors, formRefs } = useSendEmail(
		"https://server.spesna.com/api/careers/submit"
	);
	const [notification, setNotification] = useState({
		message: "",
		type: "",
		visible: false,
	});
	const [resetKey, setResetKey] = useState(0);
	const formRef = useRef(null);

	const handleChange = (e) => {
		const { name, value, files } = e.target;
		setFormData((prevData) => ({
			...prevData,
			[name]: files ? files[0] : value,
		}));
		// Clear the error for the specific field being modified
		setValidationErrors((prevErrors) => ({
			...prevErrors,
			[name]: "",
		}));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		e.stopPropagation();

		const response = await sendEmail(formData);
		if (response === "SUCCESS") {
			setNotification({
				message: "Email sent successfully!",
				type: "success",
				visible: true,
			});
			setFormData({
				fullName: "",
				email: "",
				cv: null,
			});
			setResetKey((prev) => prev + 1);
		} else {
			setNotification({
				message: "Error sending email.",
				type: "warning",
				visible: true,
			});
		}

		setTimeout(() => {
			setNotification((prev) => ({ ...prev, visible: false }));
		}, 2000);
	};

	const createHeader = (text, maxLength = 10) => {
		if (!text) return <></>;

		const parts = [""];

		for (let i = 0, index = 0; i < text.length; i++) {
			parts[index] += text[i];
			if (text[i].trim() === "" && parts[index].length > maxLength) {
				parts.push("");
				index++;
			}
		}

		return parts;
	};

	return (
		<Section id="">
			{notification.visible && (
				<NotificationBar>
					{notification.type === "success" ? (
						<NotificationContainer success={1}>
							<img src={successIcon} alt="icon" />
							<span>{notification.message}</span>
						</NotificationContainer>
					) : (
						<NotificationContainer success={0}>
							<img src={warningIcon} alt="icon" />
							<span>{notification.message}</span>
						</NotificationContainer>
					)}
				</NotificationBar>
			)}
			<SectionHeading>
				{createHeader(props.title, 11).map((item, index) => (
					<div key={index}>
						<TextRow>{item}</TextRow>
					</div>
				))}
			</SectionHeading>
			<FormContainer>
				<DescriptionContainer>
					{props.skills ? (
						<SkillWrapper>
							{props.skills.map((item, index) => (
								<SkillContainer key={index}>{item}</SkillContainer>
							))}
						</SkillWrapper>
					) : null}
					<div>
						<h3 style={{ marginTop: props.skills.length ? "50px" : "0px" }}>Position overview</h3>
						<h4>{props.positionOverview.join(" | ")}</h4>
						<p>{props.description}</p>
					</div>
					<div>
						<h3>What you'll do:</h3>
						<ul>
							{props.responsibilities.map((item, index) => (
								<li key={index}>{item}</li>
							))}
						</ul>
					</div>
					<div>
						<h3>You're a good fit if you:</h3>
						<ul>
							{props.requirements.map((item, index) => (
								<li key={index}>{item}</li>
							))}
						</ul>
					</div>
					<div>
						<h3>Why Join Us?</h3>
						<ul>
							<li>Work with a dynamic team on a variety of exciting projects.</li>
							<li>Opportunities for career development and growth.</li>
							<li>Make an impact on multiple brands through digital marketing.</li>
						</ul>
						<p>
							If you're ready to bring your expertise to Spesna, send us your CV and portfolio at
							contact@spesna.com, and let’s create something vibrant together!
						</p>
					</div>
				</DescriptionContainer>
				<Form ref={formRef} onSubmit={handleSubmit}>
					<div>
						<Input
							ref={formRefs.fullName}
							type={"text"}
							placeholder={"Name*"}
							name="fullName"
							onChange={handleChange}
							error={validationErrors.fullName ? 1 : 0}
						/>
						{validationErrors.fullName && <p>{validationErrors.fullName}</p>}
					</div>
					<div>
						<Input
							ref={formRefs.email}
							type={"text"}
							placeholder={"Email*"}
							name="email"
							onChange={handleChange}
							error={validationErrors.email ? 1 : 0}
						/>
						{validationErrors.email && <p>{validationErrors.email}</p>}
					</div>
					<div>
						<FileInput
							// ref={formRefs.siteURL}
							type={"file"}
							placeholder={"Attach your CV"}
							name="cv"
							onChange={handleChange}
							accept="image/jpeg, image/png, application/pdf"
							reset={resetKey}
							// error={validationErrors.siteURL ? 1 : 0}
						/>
						{validationErrors.siteURL && <p>{validationErrors.siteURL}</p>}
					</div>
					<div>
						<FormButton type="submit">Apply now</FormButton>
					</div>
				</Form>
			</FormContainer>
		</Section>
	);
};

export default HeroSection;
